import React, { createContext, useContext, useEffect, useState } from 'react';
import { newsArticles, requiredNewsCategories } from '../../data/newsFeed';
const initial = () => {
  try {
    const script = typeof document !== 'undefined' && document.getElementById?.('bezalel-editorial-data');
    const data = script && JSON.parse(script.textContent);
    return Array.isArray(data?.articles) && data.articles.length ? data.articles : newsArticles;
  } catch { return newsArticles; }
};
const NewsContext = createContext({ articles: newsArticles });
export function NewsProvider({ children }) {
  const [articles, setArticles] = useState(initial);
  useEffect(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    fetch('/news.php?action=list', { headers: { Accept: 'application/json' }, signal: controller.signal }).then(response => {
      if (!response.ok) throw new Error('Unavailable');
      return response.json();
    }).then(data => {
      if (Array.isArray(data.articles) && requiredNewsCategories.every(category => data.articles.some(article => article.category === category && article.status === 'published'))) setArticles(data.articles);
    }).catch(() => {}).finally(() => clearTimeout(timeout));
    return () => { controller.abort(); clearTimeout(timeout); };
  }, []);
  return <NewsContext.Provider value={{ articles }}>{children}</NewsContext.Provider>;
}
export const useNews = () => useContext(NewsContext);
